import { type ReactNode, type FC } from "react";
import { Close } from "../ui/icons";

type Props = {
  children?: ReactNode;
  canBeClosed?: boolean;
  onClose?: () => void;
  className?: string;
};

export const AlertBanner: FC<Props> = ({
  children,
  canBeClosed,
  onClose,
  className,
  ...rest
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      {...rest}
      className={`flex items-center gap-4 bg-brand-100 py-3 px-6 text-brand-500 relative ${className}`}
    >
      {children}
      {canBeClosed && (
        <div
          aria-label="close"
          className="cursor-pointer text-brand-300 hover:text-brand-500"
          onClick={handleClose}
        >
          <Close />
        </div>
      )}
    </div>
  );
};
